import { Component, HostListener } from '@angular/core';
import { Credentials, TempAuthService } from '../../services/tempAuthService';
import { SocialAuthService } from '@abacritt/angularx-social-login'
import { Router } from '@angular/router';
import { UUIDService } from '../../services/uuid.service';
import { DesktopErrorHandler } from '../../services/errorHandler.service';
import { CommonService } from 'huddyapi';
import firebase from 'firebase';
import { environment } from '../../../environments/environment';
import { AppComponent } from '../../app.component';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['../userManagementPages.scss']
})
export class LoginComponent {
  uuid: string;
  email: string;
  password: string;
  rememberMe: boolean;
  waiting: string;
  passwordShowing: boolean;

  googleReady: boolean;
  showPrivacyAgreement: boolean;

  constructor(
    public router: Router,
    private authService: TempAuthService,
    public socialAuthService: SocialAuthService,
    private uuidService: UUIDService,
    private errorHandler: DesktopErrorHandler) {
    this.waiting = null;
    this.passwordShowing = false;
    this.uuidService.getUUID().then((uuid: string) => {
      this.uuid = uuid;
    });


    this.showPrivacyAgreement = false;
  }

  togglePasswordShowing() {
    this.passwordShowing = !this.passwordShowing;
  }

  canDoLogin(): boolean {
    if(this.waiting)
      return false;
    if(!this.email || this.email.length == 0 || this.email.length > 255 || this.email.match(/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/gi) == null)
      return false;
    return !!this.password;
  }

  doLogin() {
    if(this.waiting)
      return;
    this.waiting = 'login';
    const credentials = new Credentials({
      username: this.email,
      password: this.password,
      deviceUUID: this.uuid,
      rememberMe: this.rememberMe
    });
    this.authService.login(credentials).then((user: any) => {
      let route : string = AppComponent.product === 'PROFESSIONAL' ? 'patients' : 'work-queue'; 
      this.router.navigate([route]);
      this.waiting = null;
    }, (error: any) => {
      this.errorHandler.handle(error, 'login', {
        default: (): string => {
          this.waiting = null;
          return null;
        },
        handled: (): void => {
          this.waiting = null;
          return null;
        },
        401: (): string => {
          if(typeof (error.error.AuthenticationException) == 'string' && error.error.AuthenticationException.endsWith('was not activated')) {
            this.authService.getNewVerificationCode({
              username: credentials.username,
              resetType: 'activation'
            }).subscribe(() => {
              this.router.navigateByUrl("reset/" + credentials.username);
              this.waiting = null;
            }, (error: any) => {
              this.errorHandler.handle(error, 'activation', DesktopErrorHandler.COMMON_MESSAGES);
              this.waiting = null;
            });
            return DesktopErrorHandler.MESSAGE_SILENT;
          } else {
            this.waiting = null;
            return 'Invalid credentials';
          }
        }
      });
    });
  }

  tryDoLogin() {
    if(this.canDoLogin())
      this.doLogin()
  }

  goBack() {
    if(!this.waiting)
      this.router.navigate(['']);
  }

  forgotClicked() {
    if(!this.waiting)
      this.router.navigate(['reset']);
  }

  goToCompleteRegistration() {
    if(!this.waiting)
      this.router.navigate(['complete']);
  }

  @HostListener('window:keydown.enter', ['$event'])
  handleEnter(event: any) {
    switch(event.target.tagName) {
      case 'BUTTON':
      case 'A':
        return;
      default:
        event.preventDefault();
        this.tryDoLogin();
    }
  }

  privacyDismissed(shouldLogin: boolean) {
    this.showPrivacyAgreement = false;
    if(shouldLogin)
      this.doGoogleLogin();
  }

  doGoogleLogin() {
    if(!this.googleReady || this.waiting)
      return;
    this.waiting = 'google';
    if (firebase.apps.length === 0) {
      firebase.initializeApp(environment.firebase);
    }
    // Firebase sign in is required, otherwise the idToken is considered invalid
    firebase.auth().signInWithPopup(new firebase.auth.GoogleAuthProvider()).then((user: any) => {
      firebase.auth().currentUser.getIdToken(true).then(idToken => {
        this.authService.googleLogin(user, idToken, this.uuid).then((user: any) => {
          let shouldOnboard: boolean = false;
          if(CommonService.justRegistered) {
            CommonService.justRegistered = false;
            shouldOnboard = true;
          }
          if(shouldOnboard)
            CommonService.onboardingAllowed = true;
          this.router.navigate([shouldOnboard ? 'onboarding' : AppComponent.product === 'COMMUNITY' ? 'work-queue' : 'patients']);
          this.waiting = null;
        }, async (error: any) => {
          await firebase.auth().signOut();
          this.waiting = null;
          this.errorHandler.handle(error, 'Google login', DesktopErrorHandler.COMMON_MESSAGES);
        });
      });
    }, (error: any) => {
      this.waiting = null;
      this.errorHandler.handle(error, 'Google login', DesktopErrorHandler.COMMON_MESSAGES);
    });
  }

  displayPrivacyMessage() {
    this.showPrivacyAgreement = true;
    //this.snackBar.openFromComponent(PrivacySnackBar);
  }

  doSamlAuth() {
    if (typeof window !== 'undefined') { 
        const timestamp = new Date().getTime();
        const randomNum = Math.floor(Math.random() * 1000000);
        const guid = `${timestamp}-${randomNum}`
        console.log('guid', guid);
        window.open ('https://auth-gwy.huddyhealth.com/?app=' + environment.samlApp, '_self')
        
      }
  }
}
